module.exports = __webpack_public_path__ + "static/media/AddApptIcon.fc2f36e5.svg";